var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-transporte","rota-base":"/admin/tipo-transporte","titulo":"MEIOS DE TRANSPORTE","titulo-singular":"Meio de Transporte","colunas-extras":[
        { campo: "cod_censo", label: "Cód. Censo", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }